<template lang="pug">
  .liaoning-flow
    .header
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/chongqing/marredheader.png?x-oss-process=style/414_jpeg_zoom")
    .img-desc
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/chongqing/marredprice.png?x-oss-process=style/414_jpeg_zoom")
    .form
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入重庆移动手机号")
        el-form-item
          el-col(:span="15")
            el-input.txt-verifyCode(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="4")
          el-col(:span="9")
            el-button.btn-verifyCode(:disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后重试
        el-form-item.button-item
          el-button(type="warning", @click="handelConfirm") 立即办理
    .img-desc
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/chongqing/marredrights.png?x-oss-process=style/414_jpeg_zoom")
    .img-desc
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/chongqing/marredpk.png?x-oss-process=style/414_jpeg_zoom")
    .notice
      .notice-main
        ol
          li(v-for="item in notices", :key="item")
            .content(v-if="typeof(item) === 'string'", v-html="item")
            .content(v-else)
              | {{item.text}}
              div(v-for="child in item.children", :key="child", v-html="child")
        p
          b 温馨提醒：
        ol
          li(v-for="item in tips", :key="item")
            .content(v-html="item")
    el-dialog.confirm-dialog(
      width="80%",
      title="确认办理",
      :visible.sync="dialogVisible",
      align="center"
    )
      .dialog-content
        div
          b 您要为手机号：
          span.mobile-info {{form.mobile}}
        div(style="margin-top: .4rem;")
          b 办理业务：
          .package-info 确认办理30元5G权益包产品吗？本产品包含5G通用流量+5G定向流量+视频权益会员，合约期12个月，合约期内不能办理过户、销户、合户、分户和停机保号业务。
      .dialog-footer
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 15,
        userId: '',
        goodsCode: 'TUIA20210323001',
        exchangeId: ''
      },
      channel: 'TUIA',
      dialogVisible: false,
      notices: [
        '业务资费：5G畅享权益包，本产品采用话费支付，订购立即生效，资费30元/月，合约期12个月，合约期内不能取消。合约到期后，如不取消按30元/月续订（可在合约期最后一月取消，退订次月生效）。合约期内不能办理过户、销户、合户、分户和停机保号业务，提前取消需进行违约金赔付。',
        {
          text: '本产品权益：',
          children: [
            '（1）本产品包含10GB流量（5GB全国通用流量(不含港澳台)+ 5GB定向流量）。流量到账当月内有效，不可共享/转赠/结转。',
            '（2）本产品定向流量月包（自然月，非30天），支持在优酷、百度系、爱奇艺、今日头条、抖音、咪咕视频、快手使用。（不包括APP中第三方广告、弹幕、视频上传、APP内跳转第三方网站等产生的流量）',
            '（3）每自然月内可领取一个会员权益。成功领取后会员有效期30天，会员有效期在您原有会员有效期上顺延。',
            '（4）本产品包含5G优享网速权益，使用5G手机在5G网络覆盖区域即可体验5G网速权益。',
            '（5）本产品权益包含家庭云盘（200G）、视频彩铃（基础功能）、云VR体验权益（以上三个权益均为体验3个月），到期自动取消不收取费用。'
          ]
        },
        {
          text: '权益领取规则：',
          children: [
            '（1）业务生效期间，每自然月1日起至月底，您可领取当月权益。领取机会当月有效，当月未领则作废不积累至下月，即未领取次月不能补领。',
            '（2）会员VIP领取后30分钟内充值到账。领取成功后，会员VIP时长将在您原有会员时长上顺延。请直接使用手机号码、验证码登录APP查看您的会员VIP到账情况。'
          ]
        },
        '权益领取范围：爱奇艺月会员、腾讯视频月会员、优酷月会员、哔哩哔哩月会员、芒果TV月会员、咪咕视频月会员、酷狗音乐月会员、QQ音乐月会员、酷我音乐月会员、咪咕音乐月会员、掌阅月会员、喜马拉雅月会员、QQ阅读月会员、蜻蜓FM月会员、咪咕阅读月会员（具体以权益领取页面为准）。',
        '权益领取入口：本产品订购生效后可在重庆移动手厅“我的”—“我的权益”登录领取权益。',
        '本产品限重庆移动客户办理，数据卡、物联网卡、欠费、停机、及手机状态不正常的客户不可办理本业务。'
      ],
      tips: [
        '5G畅享权益包（合约包）业务生效后12个月内不能取消。到期后如不取消按30元/月续订（可在合约期最后一月取消，退订次月生效）。',
        '合约期内不可办理过户、合户/分户、销户、离网等业务。若因特殊原因需提前取消业务，请前往营业厅处理进行费用清算，提前取消业务需按照30元/月*未履约时长赔付。',
        '业务生效期间每月可从多项VIP会员权益中任选一个使用，当月未领取次月不再补领，领取规则详见产品介绍页面。'
      ]
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.form.exchangeId = res.data.sub_data.exchangeId
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    handelConfirm() {
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 4) {
        this.$message({
          type: 'warning',
          message: '请填写4位验证码'
        })
        return;
      }
      this.dialogVisible = true
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 4) {
        this.$message({
          type: 'warning',
          message: '请填写4位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          exchangeId: this.form.exchangeId,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        exchangeId: this.form.exchangeId,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'CQFlowCommonSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.liaoning-flow{
  background-color: #F17753;
}
.header{
  img{
    width: 100%;
  }
}
.notice{
  margin-top: 2 rem;
  font: "黑体", "Arial";
  .title{
    text-align: center;
    color: #fff;
    margin-bottom: .5rem;
  }
  >.content{
    background: url('../../assets/images/liaoning/notice-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 2.5rem 2rem 1.2rem;
    border-radius: .4rem;
    margin: 0 auto;
    width: 82%;
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #4A9F94;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
    .show-more{
      text-align: center;
      font-size: .8rem;
      color: #a3a3a3;
    }
  }
}
.form{
  width: 80%;
  margin: 1rem auto 2rem;
  .el-form-item{
    margin: 3px 0;
  }
  .el-input{
    border-radius: 36px;
    overflow: hidden;
  }
  .button-item{
    text-align: center;
    .el-button{
      width: 100%;
      border-radius: 36px;
      background-color: #F5BB27;
      font-size: 1.2rem;
      padding: 1rem 0;
      box-shadow: 0 2px 2px #a3a3a3;
    }
  }
  .txt-verifyCode{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .btn-verifyCode{
    border-radius: 36px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-color: #fff;
  }
}
.protocol-content{
  color: #333;
  margin-left: .5rem;
  .protocol{
    color: rgb(48, 113, 253);
  }
}
.protocol-dialog-content{
  font-size: .6rem;
  text-align: left;
  >div{
    text-indent: 1rem;
  }
}
.img-desc{
  margin: 0 auto;
  margin-top: -.3rem;
  width: 96%;
  img{
    width: 100%;
  }
}
.notice{
  margin: 0 auto;
  margin-top: 1rem;
  width: 90%;
  color: #333;
  padding: .8rem;
  background-color: #F04737;
  position: relative;
  text-align: center;
  &::before{
    content: " ";
    background-image: url('../../../public/images/chongqing/marredimgdescheader.png');
    background-repeat: no-repeat;
    position: absolute;
    background-size: 100%;
    top: -1.5rem;
    left: 50%;
    margin-left: -25%;
    z-index: 1;
    width: 50%;
    height: 3rem;
  }
  .notice-main{
    background-color: #FDF1E4;
    border-radius: 12px;
    >ol{
      list-style-type: decimal;
      margin: 0;
      padding: 1.6rem;
      font-size: .8rem;
      text-align: left;
    }
  }
}
.dialog-content{
  text-align: left;
  font-size: 1rem;
}
.dialog-footer{
  margin-top: 2rem;
  .el-button{
    width: 40%;
  }
}
.package-info{
  text-indent: 2rem;
}
</style>
